import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import LoginRequired from './LoginRequired'

const ProtectedRoute = ({
  component: Component,
  layout: Layout,
  ensureAdmin,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => (
      <Layout>
        <LoginRequired ensureAdmin={ensureAdmin}>
          <Component {...props} />
        </LoginRequired>
      </Layout>
    )}
  />
)

ProtectedRoute.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  ensureAdmin: PropTypes.bool,
}

ProtectedRoute.defaultProps = {
  ensureAdmin: false,
}

export default ProtectedRoute
